module.exports = __webpack_public_path__ + "img/ic-warning.8a6f8212.svg";